import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const ProductNewsAndUpdatesHeader = ({ currentCategory }) => {
    let title = 'Product News and Updates';

    if (currentCategory) {
        title = currentCategory.title;
    }

    return (
        <Row className="text-center global-header-title">
            <Col>
                <h1>{title}</h1>
            </Col>
        </Row>
    );
};

ProductNewsAndUpdatesHeader.propTypes = {
    currentCategory: PropTypes.shape({
        id: PropTypes.string.isRequired, // slug
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
};

export default React.memo(ProductNewsAndUpdatesHeader);
